<template>
      <div>

         <b-container v-if="exam_buttons">
            <b-row align-h="center" align-v="center" style="height: 200px">
               <b-col sm="12" md="5" class="text-center">

                  <h2 style="padding: 32px">
                     Escolha uma prova
                  </h2>

                  <b-button v-on:click="ativar_prova_01">
                     Prova 01
                  </b-button>&nbsp;
                  <b-button v-on:click="ativar_prova_02">
                     Prova 02
                  </b-button>&nbsp;
                  <b-button v-on:click="ativar_prova_03">
                     Prova 03
                  </b-button>&nbsp;
                  <b-button v-on:click="ativar_prova_04">
                     Prova 04
                  </b-button>
               </b-col>
            </b-row>
         </b-container>


         <b-container>
            <b-row>
               <b-col v-if="activeProva01" class="text-center" style="overflow: auto; min-height: 600px"> 
                  <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeyvno89SiVjM8B010kc67yS7LG_8Ri0GGo24EQAoRtAvGt8A/viewform?embedded=true" width="640" height="600" frameborder="0" marginheight="0" marginwidth="0">Carregando…</iframe>
               </b-col>

               <b-col v-if="activeProva02" class="text-center" style="overflow: auto; min-height: 600px"> 
                  <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeCbYvcw3EuEIijBhiDYK9NBVtuGQcnscCqLH4MTayaoQA9fw/viewform?embedded=true" width="640" height="600" frameborder="0" marginheight="0" marginwidth="0">Carregando…</iframe>
               </b-col>

               <b-col v-if="activeProva03" class="text-center" style="overflow: auto; min-height: 600px"> 
                  <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSccR34eKQvCjLDdn3-MIW3pttweR6pSvUGO-A8RorTCKKW4qg/viewform?embedded=true" width="640" height="600" frameborder="0" marginheight="0" marginwidth="0">Carregando…</iframe>
               </b-col>

               <b-col v-if="activeProva04" class="text-center" style="overflow: auto; min-height: 600px"> 
                  <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfE9NJXejPzJNwbXfgM9ZxFWocjaGD4gQPF12dq2EaZ6ZR_2g/viewform?embedded=true" width="640" height="600" frameborder="0" marginheight="0" marginwidth="0">Carregando…</iframe>
               </b-col>
            </b-row>
         </b-container>



         <!-- <b-container>
            <b-row align-h="center">
                  <b-col sm="12" md="8">
                     <div id="quiz">

                        <div v-if="activeProva01">
                           <h1>{{ quiz.title }} - 01</h1>
                           <div v-for="(question, index) in quiz.prova01" v-bind:key="question.id">
                              <div v-show="index === questionIndex">
                                 <h2>{{ question.title }}</h2>
                                 <ol type="A">
                                    <li v-for="response in question.responses" v-bind:key="response.id">
                                       <label>
                                          <input type="radio" 
                                                v-bind:value="response.correct" 
                                                v-bind:name="index" 
                                                v-model="userResponses[index]"> {{response.text}}
                                       </label>
                                    </li>
                                 </ol>
                                 <button v-if="questionIndex > 0" v-on:click="prev">
                                    {{question.previous}}
                                 </button>
                                 <button v-on:click="next">
                                    {{question.next}}
                                 </button>
                              </div>
                           </div>

                           <div v-show="questionIndex === quiz.prova01.length">
                              <h2>
                                 Quiz finished
                              </h2>

                              <p>
                                 Total score: {{ score() }} / {{ quiz.prova01.length }}
                              </p>

                              <button v-on:click="results" v-show="result_btn">check results</button>

                              <div v-if="display_results === true" >                                 
                                 <ol>
                                    <li v-for="resposta in userResponses" :key="resposta">{{resposta}}</li>
                                 </ol>

                                 <div v-for="correct in quiz.prova01" :key="correct.id">
                                 <h3>Question {{correct.id}}</h3>
                                 <p><strong>Resposta certa:</strong> {{correct.correctAnswer}} </p>
                                 <p class="text-justify"><i>Explicação:</i> {{correct.explanation}} </p>
                                 </div>
                              </div>

                           </div>
                        </div>

                        <div v-if="activeProva02">
                           <h1>{{ quiz.title }} - 02</h1>
                           <div v-for="(question, index) in quiz.prova02" v-bind:key="question.id">
                              <div v-show="index === questionIndex">
                                 <h2>{{ question.title }}</h2>
                                 <ol type="A">
                                    <li v-for="response in question.responses" v-bind:key="response.id">
                                       <label>
                                          <input type="radio" 
                                                v-bind:value="response.correct" 
                                                v-bind:name="index" 
                                                v-model="userResponses[index]"> {{response.text}}
                                       </label>
                                    </li>
                                 </ol>
                                 <button v-if="questionIndex > 0" v-on:click="prev">
                                    {{question.previous}}
                                 </button>
                                 <button v-on:click="next">
                                    {{question.next}}
                                 </button>
                              </div>
                           </div>

                           <div v-show="questionIndex === quiz.prova02.length">
                              <h2>
                                 Quiz finished
                              </h2>

                              <p>
                                 Total score: {{ score() }} / {{ quiz.prova02.length }}
                              </p>

                              <button v-on:click="results" v-show="result_btn">check results</button>

                              <div v-if="display_results === true" >
                                 <ol>
                                    <li v-for="resposta in userResponses" :key="resposta">{{resposta}}</li>
                                 </ol>
                                 <div v-for="correct in quiz.prova02" :key="correct.id">
                                 <h3>Question {{correct.id}}</h3>
                                 <p><strong>Resposta certa:</strong> {{correct.correctAnswer}} </p>
                                 <p class="text-justify"><i>Explicação:</i> {{correct.explanation}} </p>
                                 </div>
                              </div>

                           </div>
                        </div>

                        <div v-if="activeProva03">
                           <h1>{{ quiz.title }} - 03</h1>
                           <div v-for="(question, index) in quiz.prova03" v-bind:key="question.id">
                              <div v-show="index === questionIndex">
                                 <h2>{{ question.title }}</h2>
                                 <ol type="A">
                                    <li v-for="response in question.responses" v-bind:key="response.id">
                                       <label>
                                          <input type="radio" 
                                                v-bind:value="response.correct" 
                                                v-bind:name="index" 
                                                v-model="userResponses[index]"> {{response.text}}
                                       </label>
                                    </li>
                                 </ol>
                                 <button v-if="questionIndex > 0" v-on:click="prev">
                                    {{question.previous}}
                                 </button>
                                 <button v-on:click="next">
                                    {{question.next}}
                                 </button>
                              </div>
                           </div>

                           <div v-show="questionIndex === quiz.prova03.length">
                              <h2>
                                 Quiz finished
                              </h2>

                              <p>
                                 Total score: {{ score() }} / {{ quiz.prova03.length }}
                              </p>

                              <button v-on:click="results" v-show="result_btn">check results</button>

                              <div v-if="display_results === true" >
                                 <ol>
                                    <li v-for="resposta in userResponses" :key="resposta">{{resposta}}</li>
                                 </ol>
                                 <div v-for="correct in quiz.prova03" :key="correct.id">
                                 <h3>Question {{correct.id}}</h3>
                                 <p><strong>Resposta certa:</strong> {{correct.correctAnswer}} </p>
                                 <p class="text-justify"><i>Explicação:</i> {{correct.explanation}} </p>
                                 </div>
                              </div>

                           </div>
                        </div>

                        <div v-if="activeProva04">
                           <h1>{{ quiz.title }} - 04</h1>
                           <div v-for="(question, index) in quiz.prova04" v-bind:key="question.id">
                              <div v-show="index === questionIndex">
                                 <h2>{{ question.title }}</h2>
                                 <ol type="A">
                                    <li v-for="response in question.responses" v-bind:key="response.id">
                                       <label>
                                          <input type="radio" 
                                                v-bind:value="response.correct" 
                                                v-bind:name="index" 
                                                v-model="userResponses[index]"> {{response.text}}
                                       </label>
                                    </li>
                                 </ol>
                                 <button v-if="questionIndex > 0" v-on:click="prev">
                                    {{question.previous}}
                                 </button>
                                 <button v-on:click="next">
                                    {{question.next}}
                                 </button>
                              </div>
                           </div>

                           <div v-show="questionIndex === quiz.prova04.length">
                              <h2>
                                 Quiz finished
                              </h2>

                              <p>
                                 Total score: {{ score() }} / {{ quiz.prova04.length }}
                              </p>

                              <button v-on:click="results" v-show="result_btn">check results</button>

                              <div v-if="display_results === true" >
                                 <ol>
                                    <li v-for="resposta in userResponses" :key="resposta">{{resposta}}</li>
                                 </ol>
                                 <div v-for="correct in quiz.prova04" :key="correct.id">
                                 <h3>Question {{correct.id}}</h3>
                                 <p><strong>Resposta certa:</strong> {{correct.correctAnswer}} </p>
                                 <p class="text-justify"><i>Explicação:</i> {{correct.explanation}} </p>
                                 </div>
                              </div>

                           </div>
                        </div>


                     </div>
                  </b-col>
            </b-row>
         </b-container> -->

      </div>
</template>

<script>
export default {
    name: 'Quiz',
    data() {
       return {
         //  quiz: quiz,
         // Store current question index
         // questionIndex: 0,
         // An array initialized with "false" values for each question
         // It means: "did the user answered correctly to the question n?" "no".
         // userResponses: Array(quiz.prova01.length).fill(false),
         display_results: false,
         result_btn: true,
         exam_buttons: true
       }
  },
  methods: {
   //  next: function() {
   //    this.questionIndex++;
   //  },
   //  prev: function() {
   //    this.questionIndex--;
   //  },
   //  score: function() {
   //    return this.userResponses.filter(function(val) { return val }).length;
   //  },
   //  results: function() {
   //    this.display_results = true;
   //    this.result_btn = false;
   //  },
    ativar_prova_01: function() {
       this.activeProva01 = true;
       this.exam_buttons = false;
    },
    ativar_prova_02: function() {
       this.activeProva02 = true;
       this.exam_buttons = false;
    },
    ativar_prova_03: function() {
       this.activeProva03 = true;
       this.exam_buttons = false;
    },
    ativar_prova_04: function() {
       this.activeProva04 = true;
       this.exam_buttons = false;
    }
  }
    
}

// var quiz = {
//   title: 'Prova',
//   prova01: [
//       {
//          id: 1,
//          title: "Marque a alternativa correta:",
//          responses: [
//             { text: "Os anticorpos antinucleares (FAN) são bastante sensíveis para o rastreio de LES.", correct: true },
//             { text: "O‌ ‌FAN‌ ‌é‌ ‌específico‌ ‌para‌ ‌o‌ ‌diagnóstico‌ ‌de‌ ‌LES,‌ ‌não‌ ‌sendo‌ ‌encontrado‌ ‌em‌ ‌outras‌ ‌doenças.‌ ‌"},
//             { text: "Os títulos de anti-DNA não devem ser utilizados para acompanhamento da NL, pois são menos específicos para o acometimento renal." },
//             { text: "Os níveis séricos de C3 e C4 estão geralmente normais na NL." }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'Os anticorpos antinucleares (FAN), encontrados em mais de 90% dos pacientes não tratados, são bastante sensíveis para o ratreio de pacientes com LES; contudo, o FAN é inespecífico e encontrado em outras doenças reumatológicas e não reumatológicas. Os anti-DNAds são mais específicos, estando presentes em cerca de 75% dos pacientes com lúpus não tratado, sendo, entretanto, um marcador menos sensível, porém são frequentemente utilizados para acompanhamento da NL. Os anticorpos anti-Sm estão fortemente associados ao diagnóstico de lúpus e à presença de nefrite, mas estão presentes em apenas cerca de 25% a 30% dos pacientes. Os níveis séricos de complemento C3 e C4 estão geralmente reduzidos, ambos ou preferencialmente C4 devido à ativação preferencial da via clássica. ',
//          correctAnswer: 'A: Os anticorpos antinucleares (FAN) são bastante sensíveis para o rastreio de LES.'
//       },
//       {
//          id: 2,
//          title: "Dentre as condições etnográficas e sociais apresentadas abaixo, a que se correlaciona com o melhor prognóstico clínico é a :",
//          responses: [
//             { text: "Raça Branca" },
//             { text: "Raça negra", correct: true },
//             { text: "Latino-americana" },
//             { text: "Baixas condições econômicas" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: '.',
//          correctAnswer: 'B: por causa da banda =D'
//       },
//       {
//          id: 3,
//          title: "Dentre as manifestações renais em pacientes com Lúpus Eritematoso Sistêmico, qual a mais prevalente:",
//          responses: [
//             { text: "Proteinúria" },
//             { text: "Hipertensão", correct: true },
//             { text: "Injúria Renal Aguda" },
//             { text: "Hematúria" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'Na população geral, a doença renal clinicamente importante ocorre em 40% dos pacientes. A NL afeta igualitariamento ambos os sexos, sendo mais grave em crianças e homens e menos graves em indivíduos idosos. É mais frequente em negros, asiáticos e hispânicos que em caucasianos. Os fatores de risco adicionais incluem condição socioeconômica baixa, mais critérios do American College of Rheumatology (ACR) para LES, maior tempo de doença, história familiar de LES e hipertensão. Em geral, o comprometimento renal se manifesta pela presença de proteinúria, sedimento urinário ativo com hematúria microscópica, dismorfismo eritrocitário, cilindro eritrocitário e hipertensão (Tabela 26-1). Nos casos de maior comprometimento renal, a síndrome nefrítica se manifesta associada a glomerulonefrite proliferativa (GN) com declínio na taxa de filtração glomerular. Os achados clínicos correlacionam-se bem com os achados histológicos glomerulares.',
//          correctAnswer: 'A: Proteinúria'
//       },
//       {
//          id: 4,
//          title: "Outlook Express is _________",
//          responses: [
//             { text: "E-Mail Client", correct: true },
//             { text: "Browser" },
//             {
//                text: "Search Engine"
//             },
//             { text: "None of the above" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'A: dhskdfjghskdfjghskdjfsdkgh'
//       }
//   ],
//   prova02: [
//       {
//          id: 1,
//          title: "What is the full form of HTTP?",
//          responses: [
//             { text: "Hyper text transfer package" },
//             { text: "Hyphenation text test program" },
//             { text: "Hyper text transfer protocol", correct: true },
//             { text: "None of the above" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'A: dhskdfjghskdfjghskdjfsdkgh'
//       },
//       {
//          id: 2,
//          title: "HTML document start and end with which tag pairs?",
//          responses: [
//             { text: "HTML", correct: true },
//             { text: "WEB" },
//             { text: "HEAD" },
//             { text: "BODY" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'B: dhskdfjghskdfjghskdjfsdkgh'
//       },
//       {
//          id: 3,
//          title: "Which tag is used to create body text in HTML?",
//          responses: [
//             { text: "HEAD" },
//             { text: "BODY", correct: true },
//             { text: "TITLE" },
//             { text: "TEXT" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'A: dhskdfjghskdfjghskdjfsdkgh'
//       },
//       {
//          id: 4,
//          title: "Outlook Express is _________",
//          responses: [
//             { text: "E-Mail Client", correct: true },
//             { text: "Browser" },
//             {
//                text: "Search Engine"
//             },
//             { text: "None of the above" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'A: dhskdfjghskdfjghskdjfsdkgh'
//       }
//   ],
//   prova03: [
//       {
//          id: 1,
//          title: "What is the full form of HTTP?",
//          responses: [
//             { text: "Hyper text transfer package" },
//             { text: "Hyper text transfer protocol", correct: true },
//             { text: "Hyphenation text test program" },
//             { text: "None of the above" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'A: dhskdfjghskdfjghskdjfsdkgh'
//       },
//       {
//          id: 2,
//          title: "HTML document start and end with which tag pairs?",
//          responses: [
//             { text: "HTML", correct: true },
//             { text: "WEB" },
//             { text: "HEAD" },
//             { text: "BODY" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'B: dhskdfjghskdfjghskdjfsdkgh'
//       },
//       {
//          id: 3,
//          title: "Which tag is used to create body text in HTML?",
//          responses: [
//             { text: "HEAD" },
//             { text: "BODY", correct: true },
//             { text: "TITLE" },
//             { text: "TEXT" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'A: dhskdfjghskdfjghskdjfsdkgh'
//       },
//       {
//          id: 4,
//          title: "Outlook Express is _________",
//          responses: [
//             { text: "E-Mail Client", correct: true },
//             { text: "Browser" },
//             {
//                text: "Search Engine"
//             },
//             { text: "None of the above" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'A: dhskdfjghskdfjghskdjfsdkgh'
//       }
//   ],
//   prova04: [
//       {
//          id: 1,
//          title: "What is the full form of HTTP?",
//          responses: [
//             { text: "Hyper text transfer package" },
//             { text: "Hyper text transfer protocol", correct: true },
//             { text: "Hyphenation text test program" },
//             { text: "None of the above" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'A: dhskdfjghskdfjghskdjfsdkgh'
//       },
//       {
//          id: 2,
//          title: "HTML document start and end with which tag pairs?",
//          responses: [
//             { text: "HTML", correct: true },
//             { text: "WEB" },
//             { text: "HEAD" },
//             { text: "BODY" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'B: dhskdfjghskdfjghskdjfsdkgh'
//       },
//       {
//          id: 3,
//          title: "Which tag is used to create body text in HTML?",
//          responses: [
//             { text: "HEAD" },
//             { text: "BODY", correct: true },
//             { text: "TITLE" },
//             { text: "TEXT" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'A: dhskdfjghskdfjghskdjfsdkgh'
//       },
//       {
//          id: 4,
//          title: "Outlook Express is _________",
//          responses: [
//             { text: "E-Mail Client", correct: true },
//             { text: "Browser" },
//             {
//                text: "Search Engine"
//             },
//             { text: "None of the above" }
//          ],
//          next: 'next',
//          previous: 'previous',
//          explanation: 'blablablablablablablabla',
//          correctAnswer: 'A: dhskdfjghskdfjghskdjfsdkgh'
//       }
//   ]
// };



</script>

<style scoped>
   #quiz {
      padding: 32px 0 32px 0;
   }
</style>